(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/tracking.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/tracking.js');
"use strict";


const trackPlay = (name, demo) => {
  svs.components.analytics.trackEvent({
    category: 'fler_lotter',
    action: demo ? 'Provspela' : 'Spela',
    opt_label: "".concat(name, "-detail")
  });
};
const trackMenuClick = name => {
  svs.components.analytics.trackEvent({
    category: 'fler_lotter_nav',
    action: 'click_secondaryMenu',
    opt_label: name
  });
};
const trackTicketCard = name => {
  svs.components.analytics.trackEvent({
    category: 'fler_lotter',
    action: 'lobby',
    opt_label: name
  });
};
setGlobal('svs.eInstant.tracking', {
  trackPlay,
  trackMenuClick,
  trackTicketCard
});

 })(window);